import { dateFromMonthCode, genMonthCodeWithOffset, monthCodeFromOffset, type MonthCode } from "@package/grid-utils";
import dayjs from "dayjs";

export const RowPeriod = ({ row }: { row: number }) => {
  // monthCodeFromOffset only covers the visible grid range (0..72). For
  // formulas that reference rows outside that range we fall back to deriving
  // the month code from the current month so we still display a label.
  const inRangeCode = monthCodeFromOffset(row) as MonthCode.MonthCodeYY | undefined;
  const baseCode = monthCodeFromOffset(0) as MonthCode.MonthCodeYY | undefined;
  const monthCode = inRangeCode ?? (baseCode ? genMonthCodeWithOffset(baseCode, row) : undefined);
  if (!monthCode) return null;
  const date = dateFromMonthCode(monthCode);
  return dayjs(date).format("MMM YY").toUpperCase();
};
